import React, { useState } from 'react';
import { cn, getInitials } from '../../utils/helpers';

interface AvatarProps {
  src?: string;
  name?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ src, name, size = 'md', className }) => {
  const [imgError, setImgError] = useState(false);

  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
  };

  const initials = name ? getInitials(name) : '?';
  const hasValidSrc = src && src.trim().length > 0 && !imgError;

  if (hasValidSrc) {
    return (
      <img
        src={src}
        alt={name || 'Avatar'}
        onError={() => setImgError(true)}
        className={cn(
          'rounded-full object-cover',
          sizeClasses[size],
          className
        )}
      />
    );
  }

  return (
    <div
      className={cn(
        'rounded-full bg-primary/20 flex items-center justify-center font-semibold text-primary',
        sizeClasses[size],
        className
      )}
    >
      {initials}
    </div>
  );
};

export default Avatar;
